import { SmartObjectCurrency as SmartObjectCurrencyBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import SmartObjectCurrencyNodeView from '@/components/editor/SmartObjectCurrencyNodeView'

export const SmartObjectCurrency = SmartObjectCurrencyBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(SmartObjectCurrencyNodeView)
    },
})
